<template>
  <v-footer app>
    <v-spacer></v-spacer>
    <span>
      &copy; {{ new Date().getFullYear() }}
      <strong>Coasul Cooperativa Agroindustrial</strong>
    </span>
  </v-footer>
</template>

<script>
export default {
  name: "FooterTemplate",
};
</script>

<style>
</style>